module.exports = __webpack_public_path__ + "static/media/Our-Story.2242ea8d.png";